import { render, staticRenderFns } from "./EditMapTabAction.vue?vue&type=template&id=53edba38&"
import script from "./EditMapTabAction.vue?vue&type=script&lang=js&"
export * from "./EditMapTabAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports